import React, { useMemo } from 'react';
import { providerApproversSelector } from '@/domain/paySettings';

import ApprovalsCellRenderer from '@/components/AgGrid/components/ApprovalsCellRenderer/index';

const PayApprovalsCellRenderer = (props) => {
  const approvalFactoryOptions = useMemo(
    () => ({
      idKey: 'account_user_id',
      pictureKey: 'avatar',
    }),
    [],
  );
  const value = Object.keys(props.value ?? {}).length ? props.value : null;

  return (
    <ApprovalsCellRenderer
      {...props}
      selectorOfApprovers={providerApproversSelector}
      approvalFactoryOptions={approvalFactoryOptions}
      value={value}
    />
  );
};

export default PayApprovalsCellRenderer;
